<template>
    <div v-if="store.title">
        <p v-if="hasTitle" class="h4">{{ store.title }}</p>
        <p class="h6 weight-300">
            {{ store.address1 }}
            <a target="_map" v-if="getMapUrl" :href="getMapUrl">
                <i class="fas fa-map-marker-alt"></i>
            </a>                                    
        </p>
        <p v-if="store.address2">
            {{ store.address2 }}
        </p>
        <p v-if="!hasFullTimeTable" class="h6 weight-300">
            {{ openMsg }}
            <button 
                class="btn btn-link"
                v-b-modal.store-info
                type="button">
                    <i class="fas fa-info-circle" ></i>
            </button>
        </p>
        <div v-else>
            <table>
                <tr v-for="(day, index) in daysName" :key="index">
                    <td class="font-weight-bold">{{day}}</td>
                    <td  v-bind:class="{ 'font-weight-bold': moment().isoWeekday() - 1 === index}"
                        >{{moment().isoWeekday() - 1 === index ? getMsgForToday() : getMsgForDay(index)}}</td>
                </tr>
            </table>
        </div>

        <b-modal
             id="store-info"
             :title="store.title"
             no-close-on-backdrop
             :no-close-on-esc="false"
             hide-footer>

            <p class="h6 weight-300">
                {{ store.address1 }}
                <a target="_map" v-if="getMapUrl" :href="getMapUrl">
                    <i class="fas fa-map-marker-alt"></i>
                </a>                                    
            </p>
            <p v-if="store.address2">
                {{ store.address2 }}
            </p>
            <p v-if="store.phone">
                {{ store.phone }}
            </p>
            <table>
                <tr v-for="(day, index) in daysName" :key="index">
                    <td class="font-weight-bold">{{day}}</td>
                    <td  v-bind:class="{ 'font-weight-bold': moment().isoWeekday() - 1 === index}"
                        >{{moment().isoWeekday() - 1 === index ? getMsgForToday() : getMsgForDay(index)}}</td>
                </tr>
            </table>

        </b-modal>
        
    </div>
</template>
<script> 

import {mapState} from 'vuex'
import moment from 'moment'

export default {
    name: 'StoreInfo',
    props:{
        hasTitle: {
            default: true,
            type: Boolean
        },
        hasFullTimeTable:{type: Boolean}
    },
    computed: {
        ...mapState({
            store: 'store'
        }),
        getMapUrl() {
            let _longtitude = this.store.longitude
            let _latitude = this.store.latitude
            var mapurl = ""

            if(_longtitude && _latitude){
                mapurl = "https://maps.google.com/?q=" + _longtitude + "," + _latitude +"&ll=" + _longtitude + "," + _latitude +"&z=10"
                if(this.getMobileOperatingSystem().toLowerCase() === 'iOS'.toLowerCase()){
                    mapurl = "maps://maps.apple.com/?ll=" + _longtitude + "," + _latitude
                }
            }else if(this.store.address1 || this.store.address2){
                mapurl = "https://www.google.com/maps/search/?api=1&query=" + encodeURI(this.store.address1 + this.store.address2)
                if(this.getMobileOperatingSystem().toLowerCase() === 'iOS'.toLowerCase()){
                    mapurl = "maps://maps.apple.com/?q=" + encodeURI(this.store.address1 + this.store.address2)
                }
            }

            return mapurl
        },        
        openMsg(){
          return this.getMsgForToday()
        }
    },
    data() {
        return {
            daysName:this.$store.getters.get7Days
        }
    },
    created(){
    },
    methods:{ 
        getMsgForDay(weekday){
            if(this.daysName === undefined || this.daysName === null){
                return ""
            }
           let dayName = this.daysName[weekday]
           let hours = this.store.hours[dayName.toLowerCase()]
           var msg = ""

           if(hours === undefined || hours === null ||hours.length === 0){
               msg = "Closed"
           } else if(hours.length === 1 && hours[0].startTime === "12:00AM" && hours[0].endTime === "11:59PM"){
               msg = "Open 24 Hours"
           } else {
               hours.forEach((hour) => {
                 let startTime = hour.startTime
                 let endTime = hour.endTime
                 msg += startTime + "-" + endTime + ", "
               })
           }
        
           msg = msg.trim()
           if(msg.slice(-1) == ","){
               msg = msg.substring(0, msg.length - 1)
           }
           return msg        
        },
        getMsgForToday() {
            var previousDay = moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(1, 'days')
			let today = moment()
            var msg = ""
            
            let previousHours = this.store.hours[previousDay.format('dddd').toLowerCase()]   
			var openByLastDay = false			
			previousHours.forEach((hour) => {
				let sT = moment(hour.startTime, ['h:ma', 'H:m']).set({second:0, millisecond:0}).subtract(1, 'days')			
				let eT = moment(hour.endTime, ['h:ma', 'H:m']).set({second:0, millisecond:0}).subtract(1, 'days')	
				
				if(!sT.isBefore(eT)){// true means this is in same day even et is in current day
					eT.add(1, 'days')					
					if(moment().isBefore(eT)){
                        openByLastDay = true
                        msg = "12:00AM" + "-" + hour.endTime
						return
					}
				}				
			})
		
			if(openByLastDay){
    			console.log("OpenByLastDay", openByLastDay ? "Yes" : "No")
			   return msg
           }

            var hours = this.store.hours[today.format('dddd').toLowerCase()]
            if(hours === undefined || hours === null ||hours.length === 0){
               msg = "Closed"
            } else if(hours.length === 1 && hours[0].startTime === "12:00AM" && hours[0].endTime === "11:59PM"){
                msg = "Open 24 Hours"
            } else {
                hours.forEach((hour) => {
                    let startTime = hour.startTime
                    let endTime = hour.endTime
                    msg += startTime + "-" + endTime + ", "
                })
            }            
            msg = msg.trim()
            if(msg.slice(-1) == ","){
                msg = msg.substring(0, msg.length - 1)
            }
            return msg  
        },       
        getMobileOperatingSystem() {
          //https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
          var OSName = "Unknown OS";
            if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
            if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
            if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
            if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
            if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";
            return OSName;
        }
    }
}
</script>
<style lang="scss" scoped>
    table {
    width: 100%;
        padding: 0 50px 0 50px;
    }     
</style>